import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ActiveModal } from '@frontend/sports/modal/feature';
import { DsButton } from '@frontend/ui/button';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { BetslipIntegrationService } from 'packages/sports/common/betslip/integration/betslip-integration.service';
import { take } from 'rxjs';

@Component({
    selector: 'ms-re-bet-clear-betslip',
    templateUrl: 'clear-betslip.html',
    styleUrl: 'clear-betslip.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [DsButton, IconCustomComponent],
})
export class ClearBetslipComponent {
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        private activeModal: ActiveModal,
        public sitecoreData: Sitecore,
        private betslipIntegrationService: BetslipIntegrationService,
    ) {}

    isBetslipCleared = false;

    onClose(): void {
        this.activeModal.close();
    }

    onClearBetslip(): void {
        this.betslipIntegrationService
            .betslipPickIds$()
            .pipe(take(1), takeUntilDestroyed(this.destroyRef))
            .subscribe((pickIds) => this.betslipIntegrationService.removeMultiplePicks({ pickIds }));
        this.isBetslipCleared = true;
    }
}
